import { useEffect } from 'react';
import { exitApp } from '../../hooks/utils';
import { useStepsState } from '../../hooks/zustandHooks';
import Container from '../container/Container';
import { useSettings } from '../../hooks/queryHooks';
import { useTranslation } from 'react-i18next';

const DocumentUplaodSuccess = () => {
  const { settings } = useSettings();
  const { t } = useTranslation();
  const setActiveStep = useStepsState(state => state.setActiveStep);

  useEffect(() => {
    setActiveStep({ stepIndex: 2 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container
      {...(settings?.redirectUrl && {
        secondaryBtn: {
          text: t('Abort & return to partner'),
          onClick: () => exitApp()
        }
      })}
    >
      <h1 className="text-xl sm:text-lg font-semi-bold uppercase text-primary-2">Thank you</h1>
      <p className="text-md font-normal text-primary-2 mb-2 mt-4">
        You have successfully uploaded your files. You can now close this window.
      </p>
    </Container>
  );
};

export default DocumentUplaodSuccess;
